var _defs, _rect, _rect2, _circle, _rect3, _circle2, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1145({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.4,
    y: 3.64,
    width: 15.2,
    height: 8.73,
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1.39,
    y: 7.43,
    width: 5.12,
    height: 3.84,
    rx: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.24,
    cy: 8.75,
    r: 0.55
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 9.49,
    y: 7.43,
    width: 5.12,
    height: 3.84,
    rx: 0.5,
    transform: "translate(24.09 18.7) rotate(-180)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 10.76,
    cy: 8.75,
    r: 0.55
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 7.5,
    y: 4.77,
    width: 1,
    height: 4.05,
    rx: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1145);
export default __webpack_public_path__ + "static/media/Symbolpack_1_145.1e5cefd2590fd85589af498b5c63cf4d.svg";
export { ForwardRef as ReactComponent };